<template>
  <div class="salesOrder">

      <div class="wrap">
        <div class="wrap__center">

          <h3>Sales Order</h3>

          <!-- btn -->
          <el-row>
            <el-col :span="24">
              <el-button type="success" plain @click="linkToCreateSalesOrder" size="mini" icon="el-icon-plus">Create sales order</el-button>
            </el-col>
          </el-row>

          <!-- table -->
          <el-row>
            <el-col :span="24">
              <el-table
                :data="tableList.filter(data => !this.search || data.subject.toLowerCase().includes(this.search.toLowerCase()))"
                style="width: 100%"
                @cell-click="cellClick">
                <el-table-column
                  label="Create Date">
                  <template slot-scope="scope">
                    <div>{{moment(scope.row.createDate * 1000).format("D MMM YY")}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Subject"
                  prop="subject">
                </el-table-column>
                <el-table-column
                  label="Status">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.isPayed == 1" style="width: 80px; text-align: center;" type="success" size="medium">Paid</el-tag>
                    <el-tag v-else size="medium">Expects</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  align="right">
                  <template slot="header" slot-scope="{}">
                    <el-input
                      v-model="search"
                      size="mini"
                      placeholder="Type to search"/>
                  </template>
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      icon="el-icon-bank-card"
                      v-if="scope.row.isPayed == 0"
                      @click="handlePay(scope.$index, scope.row)"></el-button>
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </div>
      </div>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import axios from 'axios'
  import moment from 'moment'

  export default {
    name: 'projectSalesOrder',
    computed: {
      ...mapGetters(['getSalesOrderList'])
    },
    created() {
      this.salesOrderList()
    },
    data() {
      return {
        moment:moment,

        // Main table
        tableList: [],
        search: '',
      }
    },
    methods: {
      ...mapActions(['salesOrderList']),
      cellClick(row, column, event){
        if(column.label !== 'Operations'){
          console.log('---', column);
          console.log('---', event);
        }
      },
      linkToCreateSalesOrder() {
        this.$router.push(`/create-salesOrder?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`);
      },
      handleEdit(index, row) {
        this.$router.push(`/edit-salesOrder?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&id=${row.id}`)
      },
      handleDelete(index, row) {
        this.$confirm('This will permanently delete invoice. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete Invoice'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/projectBillSheet/delete?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectBillSheetId=${row.id}`)
              .then(response => {
                  console.log('---/projectBillSheet/delete', response.data);

                  // this.$store.dispatch('salesOrderList', this.$route.query.projectId)
                  this.salesOrderList()
                  this.notification("Success", "Delete Invoice", "success");
                  loader.hide()
              })
              .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
              });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .salesOrder {
    background: #f2f4f7;
    height: 100vh;
  }

  .wrap {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 70px 10px 10px 10px;

    &__center {
      min-width: 1100px;
      h3 {
        margin: 0;
        font-size: 14px;
        color: #909399;
        margin-bottom: 10px;
      }
    }
  }

  .el-row {
    margin-bottom: 20px;
  }
</style>

